import { useMemo } from 'react';
import { CLIENTE_ID_ATENTUS } from '../common/globals/constants';

/**
 * FLINDEX visible solo si el usuario pertenece al cliente CLIENTE_ID_ATENTUS.
 */
export function isFlindexClientAccess() {
  const raw = sessionStorage.getItem('client_id');
  if (raw == null || raw === '') return false;
  return Number(raw) === CLIENTE_ID_ATENTUS;
}

export function useFlindexClientAccess() {
  return useMemo(() => isFlindexClientAccess(), []);
}
